// extracted by mini-css-extract-plugin
module.exports = {"linkHitsContainer":"linkHits_linkHitsContainer__Ll0pp","linkHitsHeader":"linkHits_linkHitsHeader__jOHBp","linkHitsItem":"linkHits_linkHitsItem__PAXj3"};